var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home content"},[_c('LayoutBanner',{attrs:{"height":"500px"}}),_c('News',{ref:"news",class:{ hide: _vm.newsHide }}),_c('About',{ref:"about",class:{ hide: _vm.aboutHide }}),_c('Work',{ref:"work",class:{ hide: _vm.workHide }}),_c('FixedBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }